import React, { type SelectHTMLAttributes } from "react";
import { FormattedMessage } from "react-intl";
import { Field } from "redux-form";
import { useGetRegionName } from "src/shared/contacts/regions/useGetRegionName";
import { InputRenderer } from "src/shared/forms/formrenderers/InputRenderer";
import type IFormInputs from "src/shared/forms/inputs/IFormInputs";
import { PleaseSelect } from "src/shared/forms/inputs/PleaseSelect";
import { required as Required } from "src/shared/forms/validations/Required";
import type { Region } from "src/shared/objects/Region";

export interface IRegionCodeInputProps
  extends IFormInputs,
    SelectHTMLAttributes<HTMLSelectElement> {
  regions: Region[];
}

export default (props: IRegionCodeInputProps) => {
  const {
    regions,
    inputID,
    label = <FormattedMessage id="contacts.region_code" />,
    ...rest
  } = props;
  const getRegionName = useGetRegionName();
  return (
    <Field
      name={inputID}
      label={label}
      type="select"
      component={InputRenderer}
      validate={[Required]}
      {...rest}
    >
      <PleaseSelect />
      {regions.map((region) => (
        <option key={region.regionCode} value={region.regionCode}>
          {getRegionName(region)}
        </option>
      ))}
    </Field>
  );
};
